
import { Component, Vue } from 'nuxt-property-decorator'
import { Context } from '@nuxt/types'
import { Severity } from '@sentry/types'
import LazyHydrate from 'vue-lazy-hydration'
import SearchForm from '~/components/SearchForm.vue'
import Exception from '~/types/Exception'
import { Division } from '~/types/Division'

@Component({
  components: {
    SearchForm,
    LazyHydrate,
    BeforeLeavePopup: () => import('@pp-frontend/popups/component/BeforeLeavePopup.vue')
  }
})
export default class extends Vue {
  popupComponent: any = () => import('~/components/Popup.vue')
  district: string = (this.$nuxt.$route.query.district as string)
  city: string = (this.$nuxt.$route.query.city as string)
  search: string = ''
  divisions!: Division[]
  dataList!: any[]

  head () {
    return {
      title: `ГИБДД ${this.subjectName} (${this.currentRegion.label}) - адреса отделений, поиск штрафов`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description
        }
      ]
    }
  }

  async asyncData (context: Context) {
    try {
      // @ts-ignore
      const divisions: Division[] = await context.$static.getGibddDivisionInfo({
        cache: true,
        requireToken: false,
        params: {
          city_name: context.query.city,
          district_name: context.query.district,
          region_code: context.query.region_id
        }
      }).then(data => Object.freeze(data.map(item => new Division(item))))

      if (divisions.length === 0) {
        throw new Exception(404)
      }

      const dataList = await context.store.dispatch('subjects/getList', context.query.region_id)
        .then(() => Object.freeze(context.store.getters['subjects/getList'].slice(0, 12)))

      return {
        divisions: divisions.map(item => item.getShortDivision()),
        dataList
      }
    } catch (err: any) {
      context.$sentry.captureMessage('Ошибка при получении страницы подразделения', Severity.Warning)
      return context.error(err)
    }
  }

  mounted () {
    window.addEventListener('mousemove', this.onScrollHandler)
    window.addEventListener('scroll', this.onScrollHandler)
  }

  onScrollHandler () {
    this.$yaMaps.addMap('map', this.divisions.map(item => item.address))
    window.removeEventListener('mousemove', this.onScrollHandler)
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  get description () {
    if (this.$route.query.region_id === '78' && this.$route.query.city === 'Санкт-Петербург') {
      return 'Узнать о наличии штрафов ГИБДД в базе данных отделения ГИБДД отдела МВД России в Санкт-Петербурге на официальном сайте'
    }

    if (this.$route.query.region_id === '77' && this.$route.query.city === 'Москва') {
      return 'Узнать о наличии штрафов ГИБДД в базе данных отделения ГИБДД отдела МВД России в Москве на официальном сайте'
    }

    return `Узнать о наличии штрафов ГИБДД в базе данных отделения ГИБДД отдела МВД России
     в ${this.currentRegion.string} (${this.subjectName}) на официальном сайте`
  }

  get header () {
    if (this.$route.query.region_id === '78' && this.$route.query.city === 'Санкт-Петербург') {
      return 'в Санкт-Петербурге'
    }

    if (this.$route.query.region_id === '77' && this.$route.query.city === 'Москва') {
      return 'в Москве'
    }

    return `${this.currentRegion.string} (${this.subjectName})`
  }

  get subjectName () {
    return this.district || this.city
  }

  get divisionList () {
    return this.divisions.filter(item => item.name.toLowerCase().includes(this.search.toLowerCase())).slice(0, 10)
  }

  get currentRegion () {
    if (!this.$route.query.region_id) {
      return {}
    }
    return this.$store.getters['regions/findByCode'](this.$route.query.region_id) || {}
  }
}
